<template>
  <div>
    <div id="openBtn" class="sc-launcher" :class="{ opened: isOpen }" v-show="false" @click.prevent="isOpen ? close() : open()">
      <!-- :style="{backgroundColor: colors.launcher.bg}" -->
      <img class="sc-open-icon" src="./assets/close-icon.png" />
      <!-- <img class="sc-closed-icon" src="/static/appicon.png" /> -->
      <img class="sc-closed-icon" :src=titleImageUrl />
      <div v-if="newMessagesCount > 0 && !isOpen" class="sc-new-messsages-count">
        {{ newMessagesCount }}
      </div>
    </div>
    <ChatWindow :isHistoryMode="isHistoryMode"  :messageList="messageList" :onUserInputSubmit="onMessageWasSent" :participants="participants"
      :gameNumber="gameNumber"
      :showHistoryMode="showHistoryMode" :title="chatWindowTitle" :titleImageUrl="titleImageUrl"
      :noconnectionImageUrl="noconnectionImageUrl" :noconnection_icon_refresh="noconnection_icon_refresh"
      :welcomBg="welcomBg" :isOpen="isOpen" :onClose="close" :onMinify="minify" :returnJSONtoMobile="returnJSONtoMobile"
      :announcements="announcements"
      :showEmoji="showEmoji" :showFile="showFile" :placeholder="placeholder" :showTypingIndicator="showTypingIndicator"
      :alwaysScrollToBottom="alwaysScrollToBottom" :messageStyling="messageStyling" @tag-clicked="tagClicked"
      :handle_logoutTimer="handle_logoutTimer" :showWelcome="showWelcome" :noconnectionType="noconnectionType"
      @handle_show-welcome="handle_showWelcome" :show_activebtnPage="show_activebtnPage"
      :handle_show_activebtnPage="handle_show_activebtnPage" :show_noconnection="show_noconnection"
      :handle_show_noconnection="handle_show_noconnection" :projectId="projectId" :projectTitleName="projectTitleName"
      :isApp="isApp" :isMobile="isMobile" :device="device" :appModule_conversation_id="appModule_conversation_id"
      :latData="latData" :streamingIn="streamingIn" :showHistoryBar="showHistoryBar" @close-game-popup="closeGamePopup"/>
    <!-- :colors="colors" -->
    <!-- :styleEdit="styleEdit" -->
  </div>
</template>
<script>
import ChatWindow from './ChatWindow.vue'

export default {
  props: {
    announcements: {
      type: Array,
      default: []
    },
    isHistoryMode: {
      type: Boolean,
      default: false
    },
    showEmoji: {
      type: Boolean,
      default: false
    },
    showHistoryMode: {
      type: Function,
      required: true
    },
    handle_logoutTimer: {
      type: Function,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    showWelcome: {
      type: Boolean,
      required: true
    },
    show_activebtnPage: {
      type: Boolean,
      required: false
    },
    handle_show_activebtnPage: {
      type: Function,
      required: true
    },
    show_noconnection: {
      type: Boolean,
      required: false
    },
    noconnectionType: {
      type: String,
      required: false,
      default: 'network'
    },
    handle_show_noconnection: {
      type: Function,
      required: true
    },
    open: {
      type: Function,
      required: true
    },
    close: {
      type: Function,
      required: true
    },
    minify: {
      type: Function,
      required: true
    },
    returnJSONtoMobile: {
      type: Function,
      required: true
    },
    showFile: {
      type: Boolean,
      default: false
    },
    participants: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: () => ''
    },
    titleImageUrl: {
      type: String,
      default: () => ''
    }, noconnectionImageUrl: {
      type: String,
      default: ''
    },
    noconnection_icon_refresh: {
      type: String,
      default: ''
    },
    welcomBg: {
      type: String,
      default: ''
    },
    onMessageWasSent: {
      type: Function,
      required: true
    },
    messageList: {
      type: Array,
      default: () => []
    },
    newMessagesCount: {
      type: Number,
      default: () => 0
    },
    placeholder: {
      type: String,
      default: '請輸入文字(限50字) ...'
    },
    showTypingIndicator: {
      type: String,
      default: () => ''
    }, projectId: {
      type: String,
      default: () => ''
    }, projectTitleName: {
      type: String,
      default: () => ''
    },
    isApp: {
      type: Boolean,
      default: false
    },
    showHistoryBar: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    device: {
      type: String,
      default: () => ''
    },
    alwaysScrollToBottom: {
      type: Boolean,
      default: () => false
    },
    messageStyling: {
      type: Boolean,
      default: () => false
    },
    appModule_conversation_id: {
      type: String,
      default: () => ''
    },
    latData: {
      type: String,
      default: () => ''
    },
    streamingIn: {
      type: Boolean,
      default: () => false
    },
    gameNumber: {
      type: Number,
      default: 0
    }
  },
  computed: {
    chatWindowTitle() {
      if (this.title !== '') {
        return this.title
      }
      if (this.participants.length > 1) {
        return 'You, ' + this.participants[0].name + ' & others'
      } else {
        return 'You & ' + this.participants[0].name
      }
    }
  },
  components: {
    ChatWindow
  },
  methods: {
    closeGamePopup() {
      this.$emit('close-game-popup')
    },
    tagClicked(value) {
      this.$emit('tag-clicked', value)
    },
    handle_showWelcome() {
      this.$emit('handle_show-welcome')
    }
  }
}
</script>

<style scoped>
@import "./styles/launcher.css";
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/Launcher.vue